import { Component, OnInit, OnDestroy } from '@angular/core';

import { ModalService } from '../../../../shared/modules/modal';

import { TinyTextEditor, TranslationConstants } from '../../../../shared/constants';
import { CompSearchContext, DiscussFinalRangeResultsModalPayload } from '../../../../shared/models';
import { CompSearchService, NotificationService } from '../../../../shared/services';
import {
  ClosableModalWithErrorResponse
} from '../../../../shared/components/base/closable-modal-with-error-response-model';

@Component({
  selector: 'discuss-final-range-results-modal',
  templateUrl: './discuss-final-range-results-modal.component.html',
})
export class DiscussFinalRangeResultsModalComponent
  extends ClosableModalWithErrorResponse
  implements OnInit, OnDestroy {

  data: DiscussFinalRangeResultsModalPayload;
  rangeDiscussion: string;

  tinyInit = TinyTextEditor.INIT;

  isDiscussionInputTouched = false;

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
    private _compSearchService: CompSearchService
  ) {
    super(notificationService, modalService);
  }

  ngOnInit(): void {
    this.rangeDiscussion = this.data.rangeDiscussion;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  close(): void {
    this.closeAllModals();
  }

  save(): void {
    this.resetErrors();
    if (this.rangeDiscussion === '' || this.rangeDiscussion === null) {
      this.responseErrors.push(TranslationConstants.ERROR_NO_DESCRIPTION);
    } else {
      const context: CompSearchContext = CompSearchContext.new(this.data);
      context.rangeDiscussion = this.rangeDiscussion;

      this._compSearchService.writeRangeDiscussion(context).subscribe(() => {
        this.success();
        this.closeAllModals();
      });
    }
  }

  setDiscussionInputTouchedState(touched = true): void {
    this.isDiscussionInputTouched = touched;
  }

}
